import React from "react";
import "./slideContent.scss";

export class SlideContentOne extends React.Component {
    render() {
        return <div className="content-three-wrap" style={{marginRight: "4.7333rem"}}>
            <div className="title">
                <div>NeuroScholar<sup>TM</sup></div>
                <div className="title-desc">多模态脑影像数据管理计算分析平台</div>
            </div>
            <div className="content">
                <p className="p-1">全国各地各中心的多模态脑影像磁共振数据，衍生出复杂且繁重的管理、计算、分析等层层嵌套的困难和需求，给科研工作者加快以脑影像大数据为基础的前沿研究步伐，带来了现实挑战。</p>
                <p>慧脑云多模态脑影像数据管理计算分析平台—NeuroScholar<sup>TM</sup>，将数据管理、质量控制、处理分析以及结果呈现等耗时费力的难点逐个击破，提供系统级的整体解决方案，全方位服务脑科学计划，为脑科学、脑医学研究和脑疾病个体化诊疗保驾护航，提高效率，加速成果产出，助力脑科学与脑医学研究向脑健康监测与脑疾病诊疗方向的成果落地。</p>
            </div>
        </div>
    }
}

export class SlideContentTwo extends React.Component {
    render() {
        return <div className="content-three-wrap" style={{marginRight: "1.3667rem"}}>
            <div className="title">
                <div>NeuroCollector<sup>TM</sup></div>
                <div className="title-desc">多模态脑影像数据质量控制系统</div>
            </div>
            <div className="content">
                <p className="p-1">随着“中国脑计划”的扬帆起航，脑重大疾病和脑智发育等研究项目，面临着建设大规模多中心脑影像队列的实际需求。在这些大规模队列研究中，多中心多模态脑影像的数据汇交质量至关重要，因此，需要完备的数据采集、汇集与质量控制方案。</p>
                <p>慧脑云多模态脑影像数据质控与管理系统——NeuroCollector<sup>TM</sup>，聚焦于磁共振设备的稳定性监测、多模态脑影像的精细化质量控制、以及海量数据的科学规整、统筹管理，通过优化数据采集与汇集流程、执行数据质量量化评估等措施，全方位提高脑影像数据采集与汇集过程中的可靠性，保障队列研究项目的顺利实施，并为后续数据深度挖掘与转化提供技术支撑。</p>
            </div>
        </div>
    }
}


export class SlideContentThree extends React.Component {
    render() {
        return <div className="content-three-wrap" style={{marginRight: "2.8rem"}}>
            <div className="title">
                <div>NeuroSignal<sup>TM</sup></div>
                <div className="title-desc">脑电图/脑磁图数据管理计算分析平台</div>
            </div>
            <div className="content">
                <p className="p-1">基于脑电图/脑磁图的神经电生理数据在基础与临床研究中的应用，目前仍面临大规模数据管理与分析的现实挑战。因此，亟需一套集成式的信息化平台，统筹数据的管理、计算与分析，进而加速科研工作者的研究产出。</p>
                <p>慧脑云脑电图/脑磁图数据管理计算分析平台——NeuroSignal<sup>TM</sup>，提供了数据管理、质量控制、处理分析以及结果呈现的整体解决方案，“一键式”完成数据规整、质量量化评估报告生成、数据标准化预处理以及灵活多样的数据深度分析功能，全方位服务脑科学基于与临床研究，为快速的临床转化提供必要的基础设施支撑，助力脑科学与脑医学研究向脑健康监测与脑疾病诊疗方向的成果落地。</p>
            </div>
        </div>
    }
}

export class SlideContentFour extends React.Component {
    render() {
        return <div className="content-three-wrap" style={{marginRight: "2.8rem"}}>
            <div className="title">
                <div>InsightEpilepsy<sup>TM</sup></div>
                <div className="title-desc">癫痫致痫灶精准定位系统</div>    
            </div>
            <div className="content">
                <p className="p-1">使用脑磁图记录癫痫患者大脑癫痫样异常放电，进行棘波溯源定位致痫灶，已被广泛应用到癫痫诊疗流程中。致痫灶的精准定位，取决于高准确率的脑磁图棘波识别，以及高稳定性的溯源算法。目前脑磁图棘波的识别主要通过医生人工视觉检测完成，棘波溯源也是依赖于医生人工操作软件，消耗医生大量的精力与时间。</p>
                <p>慧脑云癫痫致痫灶精准定位系统 —— InsightEpilepsy<sup>TM</sup>，使用人工智能算法，实现高效精准的棘波检测，检测速度较原先提升千倍。同时，软件搭载多种溯源算法，简化溯源流程，支持脑磁图棘波一键溯源。InsightEpilepsy™为癫痫的诊疗提供一套完整的标准化致痫灶定位流程，辅助医生快速完成致痫灶的定位。</p>
            </div>
        </div>
    }
}

export class SlideContentFive extends React.Component {
    render() {
        return <div className="content-three-wrap" style={{marginRight: "2.8rem"}}>
            <div className="title">
                <div>EpilepsyData<sup>TM</sup></div>
                <div className="title-desc">癫痫临床多模态数据库平台</div>
            </div>
            <div className="content">
                <p className="p-1">癫痫临床诊疗过程复杂，需要神经内科、神经外科、神经电生理科、影像科等多科室协同诊疗。患者在诊疗过程中会产生来源多样、种类繁多的临床数据；目前，市面上缺少能够融合临床信息、神经电生理、神经影像等多模态数据的管理系统。这使得癫痫临床诊疗中非常关键的数据难以规范整理并高效利用。</p>
                <p>慧脑云研发的临床癫痫多模态数据库平台通过软件、硬件、服务的有机结合，帮助癫痫中心规范、高效地建立临床癫痫数据库平台。平台即支持对病例报告表（CRF）和DICOM格式数据（CT、MRI、PET等）的统筹管理，还支持常规、长程、录像、颅内EEG、以及MEG在内的多种神经生理学数据，为建立具有典型临床特征的大样本癫痫专病数据集提供技术支撑。</p>
            </div>
        </div>
    }
}